/** @typedef {import('headlight-configurable-application').Pict} Pict */

const PictSectionInputExtension = require('pict-section-form').PictInputExtensionProvider;

class CustomInputHandler extends PictSectionInputExtension
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.isValid = false;
	}

	/**
	 * Converts the number to a phone number format.
	 * @param {string} pValue - The markdown content.
	 * @return {string} - The HTML content.
	 */
	convertToPhoneNumber(pValue)
	{
		let tmpContent = '';
		const pattern = /^\(\d{3}\) \d{3}-\d{4}$/;
		if (pValue)
		{
			if (pattern.test(pValue))
			{
				tmpContent = pValue;
				this.isValid = true;
			}
			else
			{
				// strip out any non-numeric characters, including dashes and parenthesses
				const tmpPhoneNumber = pValue.replace(/\D/g, '');
				// be smart about the phone number format based on the length of the number
				if (tmpPhoneNumber.length === 7)
				{
					tmpContent = `${tmpPhoneNumber.substring(0, 3)}-${tmpPhoneNumber.substring(3, 7)}`;
					this.isValid = true;
				}
				else if (tmpPhoneNumber.length === 10)
				{
					tmpContent = `(${tmpPhoneNumber.substring(0, 3)}) ${tmpPhoneNumber.substring(3, 6)}-${tmpPhoneNumber.substring(6, 10)}`;
					this.isValid = true;
				}
				else if (tmpPhoneNumber.length === 11)
				{
					tmpContent = `+${tmpPhoneNumber.substring(0, 1)} (${tmpPhoneNumber.substring(1, 4)}) ${tmpPhoneNumber.substring(4, 7)}-${tmpPhoneNumber.substring(7, 11)}`;
					this.isValid = true;
				}
				else
				{
					tmpContent = pValue;
					this.isValid = false;
				}
			}
		}
		return tmpContent;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean} - Returns true if the value is successfully marshaled to the form, otherwise false.
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		const tmpContent = this.convertToPhoneNumber(pValue);
		this.pict.ContentAssignment.assignContent('#' + pInput.Macro.RawHTMLID, tmpContent);
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, 0, this.isValid);

		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to a form in tabular format.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value parameter.
	 * @param {string} pHTMLSelector - The HTML selector parameter.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {any} - The result of the data marshaling.
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		const tmpContent = this.convertToPhoneNumber(pValue);
		this.pict.ContentAssignment.assignContent(('#' + pInput.Macro.RawHTMLID + '-' + pRowIndex), tmpContent);
		this.pict.providers.InputValidation.handleAlwaysActiveInputValidation(pInput, pValue, pHTMLSelector, pRowIndex, this.isValid);

		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}
}

module.exports = CustomInputHandler;
